import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "../styles/CoursesPage.css";
import CourseRatingDisplay from "../components/CourseRatingDisplay";

function CoursesPage() {

    const [courses, setCourse] = useState(null);
    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/courses`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);

            // "mamografi 14 mayıs test" kursunu filtrele
            const filteredCourses = data.filter(course =>
                course.name.toLowerCase() !== 'mamografi 14 mayıs test'
            );

            setCourse(filteredCourses);

        } catch (error) {
            console.error("Error fetching question groups:", error.message);
        }
    };
    return (
        <div className="courses-page">
            {/* Hero Header Section */}
            <div className="courses-hero">
                <div className="courses-hero-content">
                    <h1>
                        <i className="fas fa-graduation-cap"></i>
                        Kurslarımız
                    </h1>
                </div>
            </div>

            <div className="courses-container">
                <div className="course-grid">
                    {courses?.map((course) => (
                        <div key={course.id} className="course-card">

                            <img src="/images/mamografi_drawing.jpg" alt={course.name}/>

                            <div className="course-details">
                                <small><i className="fa fa-calendar"></i> Başlangıç Tarihi:{course.startDate}</small>
                                <small><i className="far fa-clock text-primary"></i> Bitiş Tarihi: {course.endDate}
                                </small>
                            </div>

                            <h3>{course.name}</h3>
                            {/*
                            <div className="course-footer">
                                                <span><i
                                                    className="fa fa-star text-primary"></i> rating </span>
                                <span>price</span>
                            </div>
    */}
                            <div className="course-buttons">
                                <Link to={`/course-details/${course.id}`}
                                      className="course-button">Detaylar</Link>

                            </div>

                            <CourseRatingDisplay courseId={course.id}/>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CoursesPage;
